import React from "react";
export default function ThanksDisplay() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center text-[#F5F0E6] p-10 text-center">
      <div>
        <div className="font-heading text-8xl text-[#D4AF37]">Danke!</div>
        <div className="mt-6 text-2xl text-[#A8A398] font-heading">Wir freuen uns aufs nächste Mal.</div>
        <div className="mt-10 text-xs uppercase tracking-[0.4em] text-[#A8A398]">THE MOVIE HOUSE · More Than Watching Movies.</div>
      </div>
    </div>
  );
}
